<template>
  <div>
    <div class="second-step">
      <a-form-model :model="parse">
        <a-collapse v-model="activeKey" expand-icon-position="right">
          <a-collapse-panel key="1" header="解析方式">
            <a-form-model-item label="选择器类型">
              <a-radio-group v-model="parse.spiderParseType">
                <a-radio :value="4"> 智能解析 </a-radio>
                <a-radio :value="1"> xpath解析器 </a-radio>
              </a-radio-group>
            </a-form-model-item>

            <a-form-model-item label="模版" class="template-select">
              <a-select
                show-search
                :value="templateContent"
                placeholder="请输入模版名称"
                style="width: 240px"
                :default-active-first-option="false"
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="null"
                @search="onTemplateContentSearch"
                @change="onTemplateContentChange"
              >
                <a-select-option v-for="d in templateContentOptions" :key="d.id">
                  {{ d.templateName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>

            <a-form-model-item label="解析规则">
              <a-card
                class="config-card"
                v-for="(item, index) in parse.spiderParseConfigs"
                :key="index"
              >
                <div slot="extra" class="card-operate">
                  <span @click="handleCopyConfig(item, index)">复制</span>
                  <!-- <span @click="handleAddConfig(index)">添加</span> -->
                  <span
                    v-if="parse.spiderParseConfigs.length > 1"
                    @click="handleDeleteConfig(index)"
                    >删除</span
                  >
                </div>
                <Rule :ruleForm="item" />
              </a-card>
            </a-form-model-item>
          </a-collapse-panel>
        </a-collapse>
      </a-form-model>
    </div>
    <div class="second-step" v-if="this.mediaType == 'news'">
      <a-form-model :model="parse">
        <a-collapse v-model="activeKey" expand-icon-position="right">
          <a-collapse-panel key="3" header="翻页配置">
            <a-form-model
              ref="ruleForm1"
              :rules="rules_fy"
              :model="spider.pageConfig"
              layout="horizontal"
              :labelCol="{ span: 5 }"
              :wrapperCol="{ span: 18, offset: 1 }"
            >
              <div class="continer">
                <a-form-model-item label="模版" class="template-label">
                  <a-select
                    show-search
                    :value="templatePagination"
                    placeholder="请输入模版名称"
                    style="width: 300px"
                    :default-active-first-option="false"
                    :show-arrow="false"
                    :filter-option="false"
                    :not-found-content="null"
                    @search="onTemplatePaginationSearch"
                    @change="onTemplatePaginationChange"
                  >
                    <a-select-option v-for="d in templatePaginationOptions" :key="d.id">
                      {{ d.templateName }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>

                <a-form-model-item label="模板参数" class="template-label-detail">
                  <a-input v-model="spider.pageConfig.templateParam" placeholder="请输入模板参数" />
                </a-form-model-item>
              </div>
            </a-form-model>
          </a-collapse-panel>
        </a-collapse>
      </a-form-model>
    </div>
    <div class="second-step" v-if="false">
      <a-form-model :model="parse">
        <a-collapse v-model="activeKey" expand-icon-position="right">
          <a-collapse-panel key="2" header="账号登录">
            <a-form-model
              ref="ruleForm"
              :rules="rules"
              :model="spider.browserConfig"
              layout="horizontal"
              :labelCol="{ span: 5 }"
              :wrapperCol="{ span: 18, offset: 1 }"
            >
              <div class="continer">
                <a-form-model-item label="账号" prop="account">
                  <a-input v-model="spider.browserConfig.account" placeholder="请输入登录账号" />
                </a-form-model-item>

                <a-form-model-item label="账号位置" prop="accountPosition">
                  <a-input
                    v-model="spider.browserConfig.accountPosition"
                    placeholder="请配置登录账号路径"
                  />
                </a-form-model-item>
                <a-form-model-item label="密码" prop="password">
                  <a-input v-model="spider.browserConfig.password" placeholder="请输入登录密码" />
                </a-form-model-item>

                <a-form-model-item label="密码位置" prop="passwordPosition">
                  <a-input
                    v-model="spider.browserConfig.passwordPosition"
                    placeholder="请配置登录密码路径"
                  />
                </a-form-model-item>
                <a-form-model-item label="登录位置" prop="loginPosition">
                  <a-input
                    v-model="spider.browserConfig.loginPosition"
                    placeholder="请配置登录路径"
                  />
                </a-form-model-item>

                <a-form-model-item label="浏览器等待时间" prop="waitTime">
                  <a-input
                    v-model="spider.browserConfig.waitTime"
                    placeholder="请输入站点名称"
                    addon-after="s"
                  />
                </a-form-model-item>
              </div>
            </a-form-model>
          </a-collapse-panel>
        </a-collapse>
      </a-form-model>
    </div>
  </div>
</template>

<script>
import Rule from './Rule'
import _ from 'lodash'
import { queryPageTemplate } from '@/api/Site/Create'
import { queryTemlateListApi } from '@/api/Site/Template'
import { onHttpResponseSilent } from '@/utils/request'

export default {
  data() {
    return {
      labelCol: { span: 2 },
      wrapperCol: { span: 22 },
      activeKey: [1, 2, 3],
      control: true,
      rules: {
        account: [{ required: true, message: '登录账号必填', trigger: 'blur' }],
        password: [{ required: true, message: '登录密码必填', trigger: 'blur' }],
        waitTime: [
          { required: true, message: '等待时间必填', trigger: 'blur' },
          { pattern: new RegExp(/^[1-9]\d*$/, 'g'), message: '请输入数字' }
        ],
        accountPosition: [{ required: true, message: '账号位置必填', trigger: 'blur' }],
        passwordPosition: [{ required: true, message: '密码位置必填', trigger: 'blur' }],
        loginPosition: [{ required: true, message: '登录位置必填', trigger: 'blur' }]
      },
      rules_fy: {
        // accountPosition: [{ required: true, message: '账号位置必填', trigger: 'blur' }],
        // passwordPosition: [{ required: true, message: '密码位置必填', trigger: 'blur' }],
        // loginPosition: [{ required: true, message: '登录位置必填', trigger: 'blur' }]
      },

      templateContent: undefined,
      templateContentOptions: [],

      templatePagination: undefined,
      templatePaginationOptions: [],
      mediaType: null
    }
  },
  props: ['parse', 'spider'],
  created() {
    let { spiderId, type } = this.$route.query
    this.mediaType = type
    if (this.spider.pageConfig.templateType !== '') {
      this.rules_fy = {
        paramType: [{ required: true, message: '参数类型必填必填', trigger: 'blur' }],
        templateParam: [{ required: true, message: '模板参数必填', trigger: 'blur' }],
        intervalTime: [
          { required: true, message: '间隔时间必填', trigger: 'blur' },
          { pattern: new RegExp(/^[1-9]\d*$/, 'g'), message: '请输入数字' }
        ]
      }
      this.control = false
    }

    this.onTemplateContentSearch()
    this.onTemplatePaginationSearch()
  },
  methods: {
    changeModel(e) {
      this.spider.pageConfig.paramType = ''
      this.spider.pageConfig.templateParam = ''
      this.spider.pageConfig.intervalTime = undefined
      if (e !== '') {
        this.rules_fy = {
          paramType: [{ required: true, message: '参数类型必填必填', trigger: 'blur' }],
          templateParam: [{ required: true, message: '模板参数必填', trigger: 'blur' }],
          intervalTime: [
            { required: true, message: '间隔时间必填', trigger: 'blur' },
            { pattern: new RegExp(/^[1-9]\d*$/, 'g'), message: '请输入数字' }
          ]
        }
        this.control = false
      } else {
        this.control = true
        this.rules_fy = {}
      }
      if (e === undefined) {
        this.control = true
        this.rules_fy = {}
      }
    },
    changeModelConfirm(e) {
      if (e !== '') {
        queryPageTemplate({
          templateType: this.spider.pageConfig.templateType,
          paramType: this.spider.pageConfig.paramType
        }).then(({ extra, code, msg }) => {
          if (code === 200) {
            this.spider.pageConfig.templateParam = extra.data.defaultParam
            if (this.spider.browserConfig.enabled === 0 && extra.data.openBrowser === 1) {
              this.$confirm({
                title: '提示',
                content: '当前翻页模板需要打开浏览器才可正常使用，是否立即开启浏览器？?',
                autoFocusButton: 'ok',
                cancelText: '暂不开启',
                okText: '立即开启',
                onOk: () => {
                  this.spider.browserConfig.enabled = 1
                },
                onCancel: () => {
                  this.spider.pageConfig.templateType = ''
                  this.spider.pageConfig.paramType = ''
                  this.spider.pageConfig.templateParam = ''
                  this.spider.pageConfig.intervalTime = undefined
                  this.control = true
                  this.rules_fy = {}
                }
              })
            }
          } else {
            this.$message.error(msg)
          }
        })
      } else {
      }
    },
    handleCopyConfig(val, index) {
      this.parse.spiderParseConfigs.splice(index, 0, _.cloneDeep(val))
    },
    handleAddConfig(index) {
      this.parse.spiderParseConfigs.splice(index + 1, 0, {
        urls: [],
        parseId: 'sputniknews_news_parse_id',
        config: [
          {
            name: 'title',
            rule: ''
          },
          {
            name: 'content',
            rule: ''
          },
          {
            name: 'publisher',
            rule: ''
          },
          {
            name: 'publish_time',
            rule: ''
          },
          {
            name: 'keywords',
            rule: ''
          },
          {
            name: 'file',
            rule: ''
          }
        ]
      })
    },
    handleDeleteConfig(index) {
      this.parse.spiderParseConfigs.splice(index, 1)
    },
    submit() {
      if (this.mediaType == 'news') {
        this.$refs.ruleForm1.validate((valid) => {
          if (valid) {
          this.$emit('changeActive')
          } else {
            this.$message.error('表单填写不完整，请检查表单')
          }
        })
      }else{
              this.$emit('changeActive')
      }
    },

    onTemplateContentSearch(text) {
      queryTemlateListApi({ templateName: text, templateType: 1, enabled: 0, pageSize: 1000 })
        .then(onHttpResponseSilent)
        .then(({ data, extra }) => {
          this.templateContentOptions = data
        })
    },

    onTemplateContentChange(value) {
      this.templateContent = value

      const tem = this.templateContentOptions.find((d) => d.id === value)
      if (!tem) {
        return
      }

      const first = this.parse.spiderParseConfigs[0]
      first.spiderConfigs?.forEach((config) => {
        let name = config.name
        if (name == 'keywords') {
          name = 'keyword'
        } else if (name == 'publish_time') {
          name = 'publisherTime'
        }
        if (tem[name]) {
          config.rule = tem[name]
        }
      })

      this.$message.success('已经成功套用模版')
    },

    onTemplatePaginationSearch(text) {
      queryTemlateListApi({ templateName: text, templateType: 0, enabled: 0, pageSize: 1000 })
        .then(onHttpResponseSilent)
        .then(({ data, extra }) => {
          this.templatePaginationOptions = data
        })
    },

    onTemplatePaginationChange(value) {
      this.templatePagination = value

      const tem = this.templatePaginationOptions.find((d) => d.id === value)
      if (tem?.param) {
        this.spider.pageConfig.templateParam = tem.param
        this.$message.success('已经成功套用模版')
      }
    }
  },
  components: {
    Rule
  }
}
</script>

<style lang="less" scoped>
.continer {
  width: 100%;
  display: grid;
  grid-template-columns: 45% 45%;
  gap: 0 60px;
}
.second-step {
  margin-bottom: 50px;
}
.config-card {
  margin-bottom: 10px;
  // min-height: 300px;
  &::before {
    margin-bottom: 0;
  }
}
.card-operate {
  span {
    margin-left: 20px;
    font-size: 14px;
    cursor: pointer;
    color: #1890ff;
  }
}

.template-select {
  display: inline-block;
  margin-top: -103px;
  margin-left: 400px;
}
</style>
